{
  "name": "@cdktf/commons",
  "version": "0.21.0",
  "publishConfig": {
    "access": "public"
  },
  "description": "CDK for Terraform Common utilities",
  "scripts": {
    "build": "tsc",
    "watch": "tsc -w",
    "watch-preserve-output": "tsc -w --preserveWatchOutput",
    "lint": "eslint . ",
    "lint:fix": "eslint . --fix",
    "pretest": "yarn build",
    "pretest:ci": "yarn build",
    "test": "yarn lint && jest",
    "test:ci": "yarn lint && jest --ci",
    "jest-watch": "jest --watch",
    "package": "./package.sh",
    "dist-clean": "rm -rf dist"
  },
  "main": "src/index.js",
  "types": "src/index.d.ts",
  "repository": {
    "type": "git",
    "url": "git://github.com/hashicorp/terraform-cdk.git",
    "directory": "packages/@cdktf/commons"
  },
  "author": {
    "name": "HashiCorp",
    "url": "https://hashicorp.com"
  },
  "keywords": [
    "cdk",
    "cdktf",
    "terraform"
  ],
  "license": "MPL-2.0",
  "dependencies": {
    "@sentry/node": "7.120.3",
    "cdktf": "0.21.0",
    "ci-info": "3.9.0",
    "codemaker": "1.112.0",
    "cross-spawn": "7.0.6",
    "follow-redirects": "1.15.9",
    "fs-extra": "11.3.0",
    "log4js": "6.9.1",
    "strip-ansi": "6.0.1",
    "uuid": "9.0.1",
    "validator": "13.15.0"
  },
  "devDependencies": {
    "@eslint/compat": "^1.2.9",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.27.0",
    "@types/follow-redirects": "1.14.4",
    "@types/fs-extra": "11.0.4",
    "@types/uuid": "9.0.8",
    "@types/validator": "13.15.0",
    "@typescript-eslint/parser": "^8.32.1",
    "eslint": "^9.27.0",
    "eslint-plugin-prettier": "^5.4.0",
    "eslint-plugin-react": "7.37.5",
    "jest": "^29.7.0",
    "lint-staged": "^15.5.2",
    "ts-jest": "29.3.4",
    "typescript": "5.4.5",
    "typescript-eslint": "^8.32.1"
  },
  "lint-staged": {
    "src/**/*.{ts,tsx}": "tsc-files ambient.d.ts --noEmit"
  }
}
